<template>
    <div>
        <h3>跟进记录详情</h3>
        <el-form :model="followInfo" :rules="rules" ref="followInfo" class="demo-form-inline" size="mini" label-width="180px">
            <el-form-item label="客户id">
                {{followInfo.userId}}
            </el-form-item>
            <el-form-item label="客户昵称">
                {{followInfo.nickname}}
            </el-form-item>
            <el-form-item label="客户手机">
                {{followInfo.phoneNumber}}
            </el-form-item>
            <el-form-item label="客户姓名">
                <el-input type="text" v-model="followInfo.clientNickname"></el-input>
            </el-form-item>
            <el-form-item label="公司职位">
                <el-input type="text" v-model="followInfo.clientPosition"></el-input>
            </el-form-item>
            <el-form-item label="客户级别">
                <el-row>
                    <el-col :span="12">    
                        <el-select v-model="followInfo.customerLevel" :clearable="true" placeholder="请选择客户级别">
                            <el-option v-for="item,key in map.user.customerLevel" :key="key" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="8" :offset="1">
                        <a :href="`/clientlevel?id=${followInfo.userId}`" target="_blank">客户级别</a>
                    </el-col>
                </el-row>
            </el-form-item>
            <el-form-item label="公司信息">
                <el-input type="text" v-model="followInfo.companyName"></el-input>
            </el-form-item>
            <el-form-item label="用户来源">
                <el-input type="text" v-model="followInfo.utmSource"></el-input>
            </el-form-item>
            <el-form-item label="关联职位">
                <el-select size="medium" :clearable="true" :multiple="true" value-key="jobId" placeholder="请选择关联职位" v-model="followInfo.jobInfoList">
                    <el-option v-for="item in clientInfo.jobInfoList" :value="item" :label="item.jobTitle" :key="item.jobId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="跟进内容" prop="followContent">
                <el-input type="textarea" :rows="5" v-model="followInfo.followContent"></el-input>
            </el-form-item>
            <el-form-item label="">
                <ul class="records" v-if="historyRecord.length">
                    <li v-for="item in historyRecord">{{item.updateTime}} {{item.founder}} {{item.followContent}}</li>
                </ul>
            </el-form-item>
            <el-form-item label="跟进状态" prop="followStatus">
                <el-select v-model.number="followInfo.followStatus" placeholder="请选择跟进状态">
                    <el-option v-for="item,key in map.client.followStatus" :key="key" :label="item" :value="Number(key)"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item v-if="followInfo.followStatus === 2" label="释放原因" prop="releaseReason">
                <el-select v-model="followInfo.releaseReason" placeholder="请选择释放原因">
                    <el-option v-for="item in releaseReason" :key="item.id" :label="item.reason" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="下次跟进时间">
                <el-date-picker v-model="followInfo.nextFollowTime" type="datetime" placeholder="下次跟进时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="联系方式">
                <el-input type="text" v-model="followInfo.clientContactInfo"></el-input>
            </el-form-item>
            <el-form-item label="客户邮箱">
                <el-input type="text" v-model="followInfo.clientEmail"></el-input>
            </el-form-item>
            <el-form-item label="跟进人">
                {{followInfo.founder}}
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="submit">保存</el-button>
                <a :href="`/user-detail?userId=${followInfo.userId}`" target="_blank">查看认证信息</a>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import api from '../api'
import map from '../../datamap'
import moment from 'moment'
export default {
    name: "jobDetail",
    data() {
        return {
            map,
            followInfo: {
                userId: '',
                nickname: '',
                clientNickname: '',
                clientPosition: '',
                customerLevel: '',
                companyName: '',
                utmSource: '',
                jobInfoList: [],
                followContent: '',
                nextFollowTime: '',
                clientContactInfo: '',
                clientEmail: '',
                founder: '',
                releaseReason: '',
            },
            historyRecord: {},
            clientInfo: {},
            rules: {
                followContent: [{
                    required: true,
                    message: '请输入跟进内容',
                    trigger: 'blur'
                }],
                releaseReason: [{
                    required: true,
                    message: '请选择释放原因',
                    trigger: 'change'
                }],
            },
            isSubmiting: false,
            releaseReason: [],
        };
    },
    computed: {
        id() {
            return this.$route.query.id;
        },
        userId() {
            return this.$route.query.userId;
        },
        jobId() {
            return this.$route.query.jobId;
        },
        username() {
            return localStorage.getItem('username');
        },
        from() {
            return this.$route.query.from;
        },
    },
    watch: {
        'followInfo.customerLevel'(val) {
            let days = 0;
            switch(val) {
                case 'KA':
                case 'A':
                    days = 1;
                    break;
                case 'B':
                    days = 2;
                    break;
                case 'C':
                    days = 3;
                    break;
                case 'D':
                    days = 4;
                    break;
                default:
            }
            this.followInfo.nextFollowTime = moment().add(days, 'd').format('YYYY-MM-DD HH:mm:ss');
        },
        'followInfo.followStatus'(val) {
            if (val !== 2) {
                this.followInfo.releaseReason = '';
            }
        },
    },
    created() {
        this.followInfo.founder = this.username;
    },
    mounted() {
        this.getReleaseReason();
        if (this.id) {
            this.getFollowDetail();
        } else {
            this.getClientInfo();
        }
    },
    methods: {
        async getReleaseReason() {
            let {
                data: {
                    code,
                    data,
                }
            } = await api.common.getReasons({type: 1});
            if (code == 200) {
                this.releaseReason = data;
            } 
        },
        async getFollowDetail() {
            let {
                data: {
                    code,
                    data,
                }
            } = await api.client.followDetail({
                id: this.id
            });
            if (code == 200) {
                this.followInfo = data.followRecord;
                this.historyRecord = data.historyRecord;

                this.$set(this.followInfo, 'releaseReason', !data.followRecord.releaseReason || data.followRecord.releaseReason == 0 ? '' : data.followRecord.releaseReason)
                this.getClientInfo();
            }
        },
        async getClientInfo() {
            let {
                data: {
                    code,
                    data,
                }
            } = await api.client.clientInfo({
                userId: this.userId || this.followInfo.userId
            });
            if (code == 200) {

                let clientInfo = this.clientInfo = data.followRecord;

                this.historyRecord = data.historyRecord;
                this.followInfo.clientContactInfo = clientInfo.clientContactInfo;
                this.followInfo.clientNickname = clientInfo.clientNickname;
                this.followInfo.clientPosition = clientInfo.clientPosition;
                this.followInfo.customerLevel = clientInfo.customerLevel;
                this.followInfo.clientEmail = clientInfo.clientEmail;
                this.followInfo.companyName = clientInfo.companyName;
                this.followInfo.nickname = clientInfo.nickname;
                this.followInfo.phoneNumber = clientInfo.phoneNumber;
                this.followInfo.utmSource = clientInfo.utmSource;
                this.followInfo.userId = clientInfo.userId || this.userId;
                
                this.$set(this.followInfo, 'followStatus', clientInfo.followStatus);
                this.$set(this.followInfo, 'releaseReason', !data.followRecord.releaseReason || data.followRecord.releaseReason == 0 ? '' : data.followRecord.releaseReason);

                let jobs = clientInfo.jobInfoList || [];
                if (this.jobId && jobs.length && !this.followInfo.jobInfoList.length) {
                    for(let i=0;i<jobs.length;i++) {
                        if (jobs[i].jobId == this.jobId) {
                            this.followInfo.jobInfoList.push(jobs[i]);
                            break;
                        }
                    }
                }
            }
        },
        submit() {
            this.$refs.followInfo.validate(valid => {
                if (valid) {
                    this.save();
                } else {
                    return false;
                }
            })
        },
        async save() {
            if (this.isSubmiting) return false;
            this.isSubmiting = true;
            let {
                userId,
                nickname,
                clientNickname,
                clientPosition,
                customerLevel,
                companyName,
                utmSource,
                jobInfoList,
                followContent,
                nextFollowTime,
                clientContactInfo,
                clientEmail,
                founder,
                followStatus,
                releaseReason,
            } = this.followInfo;
            let obj = {
                userId: Number.isInteger(userId) ? userId : '',
                nickname,
                clientNickname,
                clientPosition,
                customerLevel,
                companyName,
                utmSource,
                jobInfoList,
                followContent,
                nextFollowTime,
                clientContactInfo,
                clientEmail,
                founder,
                followStatus,
                releaseReason: !releaseReason ? 0 : releaseReason,
            }
            if (this.id) {
                obj.id = this.id;
            }
            let {
                data: {
                    code,
                    data,
                }
            } = await api.client.followSave(obj);
            if (code == 200) {
                let vue = this;
                this.$message({
                    showClose: true,
                    message: '跟进记录保存成功',
                    type: 'success',
                    onClose() {
                        if (vue.from) {
                            window.location.href = `/${vue.from}`;
                        }
                    }
                })
                
            }
            this.isSubmiting = false;
        },
    },
};
</script>
<style scoped>
.records {
    list-style: none;
}
.records li {
    margin-top: 10px;
    word-break: break-all;
    color: #aaa;
    line-height: 24px;
}
.demo-form-inline {
    width: 640px;
}
.el-select {
    width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/client/follow-detail.vue